export default __webpack_public_path__ + "images/b1640959458994cdc961e80302f56c3a-metric_intro.png";